import axios from "axios"

/*
 비용 기반 AI 크레딧 API (user-app v2, 연동 매뉴얼 2026-10-29 개정 2 · 계약 COST_1)
 - GET  /user-app/v2/users/{USER_NO}/credits                              잔액 조회
 - POST /user-app/v2/users/{USER_NO}/credits/estimates                    전체 요청 견적(기록 없음)
 - POST /user-app/v2/users/{USER_NO}/credits/requests                     전체 요청 승인(차감·예약 없음)
 - POST /user-app/v2/users/{USER_NO}/credits/calls/{callId}/start         외부 AI 호출 시작 승인
 - POST /user-app/v2/users/{USER_NO}/credits/calls/{callId}/complete      실제 사용량 정산
 - POST /user-app/v2/users/{USER_NO}/credits/calls/{callId}/unknown       사용량 미확인 기록(본문 없음)
 - POST /user-app/v2/users/{USER_NO}/credits/requests/{requestId}/close   미시작 호출 종료(본문 없음)
 이전 토큰 1:1 방식의 /credits/jobs 는 서버에서 없어졌다(2026-11-02 dev-saas 404).

 상태 코드와 errors[].code 로 분기해야 해서 오류를 null 로 삼키는 apiHandler 대신 axios 를 직접 쓴다.
 기본 인스턴스라 dot-framework 의 쿠키·토큰 갱신 인터셉터는 그대로 탄다.
 사용자는 경로의 USER_NO 로만 지정한다(본문·쿼리에 다시 넣지 않는다). 형식 검사는 aiCredit.mjs 가 한다.

 응답은 {status, data} 로 돌려준다. 응답을 못 받으면 status 0.
 */

const BASE = "/user-app/v2/users"

async function send(method, url, data) {
    try {
        const response = await axios({
            method,
            url,
            data,
            withCredentials: true,
            // axios 0.x 기본값(application/json;charset=utf-8)을 쓰지 않고 매뉴얼에 적힌 그대로 보낸다.
            // unknown·close 는 본문 없이 보낸다(본문이 없으면 Content-Type 도 붙이지 않는다).
            headers: data === undefined ? undefined : {"Content-Type": "application/json"},
        })
        return {status: response.status, data: response.data}
    } catch (error) {
        if (error?.response) return {status: error.response.status, data: error.response.data}
        return {status: 0, data: null}
    }
}

const enc = encodeURIComponent

export default {
    getCredits(userNo) {
        return send("get", `${BASE}/${enc(userNo)}/credits`)
    },
    estimate(userNo, plan) {
        return send("post", `${BASE}/${enc(userNo)}/credits/estimates`, plan)
    },
    approveRequest(userNo, plan) {
        return send("post", `${BASE}/${enc(userNo)}/credits/requests`, plan)
    },
    startCall(userNo, callId, body) {
        return send("post", `${BASE}/${enc(userNo)}/credits/calls/${enc(callId)}/start`, body)
    },
    completeCall(userNo, callId, body) {
        return send("post", `${BASE}/${enc(userNo)}/credits/calls/${enc(callId)}/complete`, body)
    },
    markCallUnknown(userNo, callId) {
        return send("post", `${BASE}/${enc(userNo)}/credits/calls/${enc(callId)}/unknown`)
    },
    closeRequest(userNo, requestId) {
        return send("post", `${BASE}/${enc(userNo)}/credits/requests/${enc(requestId)}/close`)
    },
}
